module.exports = [
  { id: '1TO1_COACHING', name: 'One to One Coaching' },
  { id: '2TO1_COACHING', name: 'Two to One Coaching' },
  { id: 'GROUP_COACHING', name: 'Group Coaching' }
]
